import { STORAGE_KEY_APP_DATA } from "../../../services/managers/constants";
import appDataTransformer from "../../../services/transformers/app-data";
import webStorageManager from "../../../services/managers/web-storage";
import securityManager from "../../../services/managers/security";
import chartMetaData from "../../../services/transformers/chart-meta-data";

export const onSelectedProductChangeHandler = (state, action) => {
  let chartWhiteboards = state.chartWhiteboards.slice();
  let chartWhiteboardsLen = chartWhiteboards.length;

  // Fetch new set of Lot Sizes mapped to Product
  let __AppData = webStorageManager.get(STORAGE_KEY_APP_DATA);
  let costToTradeLotSizes = appDataTransformer.getAllLotSizesByProduct(__AppData.App.Products, action.payload.value);

  for (let index = 0; index < chartWhiteboardsLen; index++) {
    let whiteboard = { ...chartWhiteboards[index] };
    // Re-populating selected Lot Sizes
    whiteboard.selectedCostToTradeLotSizes = [];
    whiteboard.selectedCostToTradeLotSizes[0] = costToTradeLotSizes[0].Key;
    // Obsoleting Whiteboard
    whiteboard.isObsolete = true;
    whiteboard.__change_detection_key = securityManager.generateKey();
    chartWhiteboards[index] = whiteboard;
  }

  return { ...state, selectedProduct: action.payload.value, costToTradeLotSizes, chartWhiteboards };
};

export const onSelectedDateRangeChangeHandler = (state, action) => {
  let chartWhiteboards = state.chartWhiteboards.slice();
  let chartWhiteboardsLen = chartWhiteboards.length;

  let processedGranularities = chartMetaData.getEnabledDisabledGranularities(
    action.payload.which === "from" ? action.payload.value.unix() : state.selectedDateRangeFrom,
    action.payload.which === "from" ? state.selectedDateRangeTo : action.payload.value.unix(),
    state.selectedZone
  );

  for (let index = 0; index < chartWhiteboardsLen; index++) {
    let whiteboard = { ...chartWhiteboards[index] };
    if (whiteboard.chartDrawings.length) {
      whiteboard.granularities = processedGranularities;
      whiteboard.selectedGranularity = chartMetaData.getNewSelectedGranularityBasedOnEnabledDisabledState(
        processedGranularities,
        whiteboard.selectedGranularity
      );
      // Obsoleting Whiteboard
      whiteboard.isObsolete = true;
      whiteboard.__change_detection_key = securityManager.generateKey();
      chartWhiteboards[index] = whiteboard;
    }
  }

  return action.payload.which === "from"
    ? { ...state, selectedDateRangeFrom: action.payload.value.unix(), chartWhiteboards }
    : { ...state, selectedDateRangeTo: action.payload.value.unix(), chartWhiteboards };
};

export const onSelectedZoneChangeHandler = (state, action) => {
  let chartWhiteboards = state.chartWhiteboards.slice();
  let chartWhiteboardsLen = chartWhiteboards.length;
  let processedGranularities = chartMetaData.getEnabledDisabledGranularities(
    state.selectedDateRangeFrom,
    state.selectedDateRangeTo,
    action.payload.value
  );

  for (let index = 0; index < chartWhiteboardsLen; index++) {
    let whiteboard = { ...chartWhiteboards[index] };
    if (whiteboard.chartDrawings.length) {
      whiteboard.granularities = processedGranularities;
      whiteboard.selectedGranularity = whiteboard.selectedGranularity = chartMetaData.getNewSelectedGranularityBasedOnEnabledDisabledState(
        processedGranularities,
        whiteboard.selectedGranularity
      );
      // Obsoleting Whiteboard
      whiteboard.isObsolete = true;
      whiteboard.__change_detection_key = securityManager.generateKey();
      chartWhiteboards[index] = whiteboard;
    }
  }

  return { ...state, selectedZone: action.payload.value, chartWhiteboards };
};



// WEBPACK FOOTER //
// ./src/store/analytics/chart-filters/action-handlers.js